import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "grid-3 gap-sm" }
const _hoisted_2 = { class: "panel span-2" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { value: "" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { value: "" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]

import { computed, onBeforeMount, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ErrorBag, handleFormError } from '@/core/common';
import { getValueInUserLanguage } from '@/core/languageContent';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import PageLayout from '@/core/components/PageLayout.vue';
import AppInput from '@/core/components/form/AppInput.vue';
import AppTextarea from '@/core/components/form/AppTextarea.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';
import { TicketCreate, useTicket, addedViaNames } from '../Ticket';
import { CustomerStub } from '@/modules/customer/Customer';
import { TicketCategory } from '@/modules/ticket_category/TicketCategory';
import { useLawFirm } from '@/modules/law_firm/LawFirm';
import { User } from '../../user/User';

interface TicketFormProps {
	ticket: TicketCreate;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketCreateForm',
  props: {
    ticket: {}
  },
  emits: [
	'cancel',
	'saved',
],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { $gettext } = useGettext();
const resource = useTicket();
const lawFirmResource = useLawFirm();
const store = useStore<AppStore>();
const authUser = computed<User>(() => store.state.authenticatedUser as User);
const isLawFirmUser = computed<boolean>(() => !!authUser.value.law_firm);
const errors = ref<ErrorBag>({});
const data = ref<Partial<TicketCreate>>({});
const addedViaOptions = computed(() => {
	return Object.entries(addedViaNames).filter(([type]) => type !== 'FORM');
})
const customerOptions = ref<CustomerStub[]>([]);
const ticketCategoryOptions = computed<TicketCategory[]>(() => store.getters.ticketCategories);

onBeforeMount(async () => {
	if (authUser.value.law_firm) {
		customerOptions.value = await lawFirmResource.getConnectedCustomers(authUser.value.law_firm.id);
	}

	await store.dispatch('loadTicketCategories');
});

// Set data to form on mount and when the prop value changes.
const setData = () => data.value = Object.assign({}, props.ticket);
onMounted(setData);
watch(() => props.ticket, setData);

const save = async () => {
	errors.value = {};

	const postBody: TicketCreate = Object.assign({}, data.value) as TicketCreate;

	try {
		const response = await resource.post(postBody);

		emit('saved', response);

	} catch (e) {
		return handleFormError(e as Error, errors);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Nytt ärende'),
    "base-tag": "form",
    onSubmit: _withModifiers(save, ["prevent"])
  }, {
    "header-actions": _withCtx(() => [
      _createVNode(AppButton, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Avbryt")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppButton, { type: "submit" }, {
        default: _withCtx(() => [
          _createVNode(_component_translate, null, {
            default: _withCtx(() => [
              _createTextVNode("Spara")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createElementBlock("h2", null, [
            _createTextVNode("Ärendeinformation")
          ])), [
            [_directive_translate]
          ]),
          _createVNode(AppFormGroup, {
            id: "ticket_reporter_name",
            errors: errors.value.reporter_name,
            label: _unref($gettext)('Rapportörens namn (frivilligt)')
          }, {
            default: _withCtx(() => [
              _createVNode(AppInput, {
                id: "ticket_reporter_name",
                modelValue: data.value.reporter_name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.reporter_name) = $event)),
                maxlength: "64"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors", "label"]),
          _createVNode(AppFormGroup, {
            id: "ticket_when",
            errors: errors.value.when,
            label: _unref($gettext)('När inträffade detta?') + ' *'
          }, {
            default: _withCtx(() => [
              _createVNode(AppInput, {
                type: "date",
                id: "ticket_when",
                modelValue: data.value.when,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.value.when) = $event)),
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors", "label"]),
          _createVNode(AppFormGroup, {
            id: "ticket_description",
            errors: errors.value.description,
            label: _unref($gettext)('Vad handlar din rapport om?') + ' *'
          }, {
            default: _withCtx(() => [
              _createVNode(AppTextarea, {
                type: "description",
                id: "ticket_description",
                modelValue: data.value.description,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.value.description) = $event)),
                required: "",
                maxlength: "65535"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors", "label"]),
          _createVNode(AppFormGroup, {
            id: "ticket_where",
            errors: errors.value.where,
            label: _unref($gettext)('Var hände detta?') + ' *'
          }, {
            default: _withCtx(() => [
              _createVNode(AppTextarea, {
                type: "where",
                id: "ticket_where",
                modelValue: data.value.where,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.value.where) = $event)),
                required: "",
                maxlength: "65535"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors", "label"]),
          _createVNode(AppFormGroup, {
            id: "ticket_what",
            errors: errors.value.what,
            label: _unref($gettext)('Beskriv vad som hände') + ' *'
          }, {
            default: _withCtx(() => [
              _createVNode(AppTextarea, {
                type: "what",
                id: "ticket_what",
                modelValue: data.value.what,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.value.what) = $event)),
                required: "",
                maxlength: "65535"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors", "label"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives((_openBlock(), _createElementBlock("h2", null, [
            _createTextVNode("Egenskaper")
          ])), [
            [_directive_translate]
          ]),
          (isLawFirmUser.value)
            ? (_openBlock(), _createBlock(AppFormGroup, {
                key: 0,
                id: "ticket_details_added_via",
                errors: errors.value.added_via,
                label: "Inkom genom"
              }, {
                default: _withCtx(() => [
                  _createVNode(AppSelect, {
                    id: "ticket_details_added_via",
                    modelValue: data.value.added_via,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((data.value.added_via) = $event)),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_4, [
                        _createTextVNode("(Ej vald)")
                      ])), [
                        [_directive_translate]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addedViaOptions.value, ([addedVia, addedViaName]) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: addedVia,
                          value: addedVia
                        }, _toDisplayString(addedViaName), 9, _hoisted_5))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors"]))
            : _createCommentVNode("", true),
          (isLawFirmUser.value)
            ? (_openBlock(), _createBlock(AppFormGroup, {
                key: 1,
                id: "ticket_details_customer",
                errors: errors.value.customer,
                label: _unref($gettext)('Kund')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppSelect, {
                    id: "ticket_details_customer",
                    modelValue: data.value.customer,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((data.value.customer) = $event)),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_6, [
                        _createTextVNode("(Ej vald)")
                      ])), [
                        [_directive_translate]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customerOptions.value, (customer) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: customer.id,
                          value: customer.id
                        }, _toDisplayString(customer.name), 9, _hoisted_7))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["errors", "label"]))
            : _createCommentVNode("", true),
          _createVNode(AppFormGroup, {
            id: "ticket_details_category",
            errors: errors.value.ticket_category,
            label: _unref($gettext)('Kategori')
          }, {
            default: _withCtx(() => [
              _createVNode(AppSelect, {
                id: "ticket_details_category",
                modelValue: data.value.ticket_category,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((data.value.ticket_category) = $event))
              }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_8, [
                    _createTextVNode("(Ej vald)")
                  ])), [
                    [_directive_translate]
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ticketCategoryOptions.value, (ticketCategory) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: ticketCategory.id,
                      value: ticketCategory.id
                    }, _toDisplayString(_unref(getValueInUserLanguage)(ticketCategory.content)), 9, _hoisted_9))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["errors", "label"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["page-title", "onSubmit"]))
}
}

})